export default __webpack_public_path__ + "static/media/list1.160b7025.svg";